// extracted by mini-css-extract-plugin
export default {"box":"Wallet_box__Oa-Iq","container":"Wallet_container__+ETL3","flex":"Wallet_flex__oAQs5"};